import {
	Home9,
	Theme9Introduction,
	Theme9SubtopicOneActivityOne,
	Theme9SubtopicOneActivityTwo,
	Theme9SubtopicOneActivityThree,
	Theme9SubtopicOneActivityFour,
	Theme9SubtopicOneFinalPoints,
	SubtopicFinalTema9,
} from "../pages/tema9";



export const pathTeam9 = {
	path: "home9",
	element: <Home9 />,
	children: [
		{
			path: "tema9",
			children: [
				{
					path: "introduction",
					element: <Theme9Introduction />,
				},
				{
					path: "subtema1",
					children: [
						{
							path: "activityOne",
							element: <Theme9SubtopicOneActivityOne />,
						},
						{
							path: "activityTwo",
							element: <Theme9SubtopicOneActivityTwo />,
						},
						{
							path: "activityThree",
							element: <Theme9SubtopicOneActivityThree />,
						},
						{
							path: "activityFour",
							element: <Theme9SubtopicOneActivityFour />,
						},
						{
							path: "activityresult",
							element: <Theme9SubtopicOneFinalPoints />,
						},
					],
				},
				{
					path: "final",
					element: <SubtopicFinalTema9 />,
				},
			],
		}
	]
}